
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table } from "@common/src/utils/decorator";
import { InjectFunction } from "@common/src/utils/decorator";
import t from "@common/src/i18n/t";
import { OpDefalutQueryStore } from "@common/src/utils/constant";

const base = namespace("base");
const staff = namespace("staff");
const setting = namespace("setting");
const inventory = namespace("inventory");
const management = namespace("management");
const app = namespace("app");
@InjectFunction("dayjs", "emptyToLine", "splitThousands", "permit", "permitApp", "appCode", "addCurrencySymbol")
@Component({})
@Table("loadListData")
export default class ServiceList extends Vue {
  @base.Action getDictionaryList;
  @staff.Action getStaffList;
  @setting.State serviceMode;
  @inventory.Action getOutWarehouseList;
  @inventory.Action outWarehouseComplete;
  @inventory.Action getOutWarehouseDetail;
  @inventory.Action queryInventoryAndNotice;
  @management.Action getStoreList;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  orderList: any[] = [];
  searchForm = {
    storeCode: "",
    outboundType: "",
    outboundUser: "",
    startOutboundDate: "",
    endOutboundDate: "",
    outboundStatus: "",
    customerPlateCode: "",
    orderNo: "",
    outboundNo: ""
  };
  orderStatusList: any[] = [];
  orderTypeList: any[] = [];
  staffList: any[] = [];
  created() {
    if (this.permitApp("speedbiz-operation")) {
      this.searchForm.storeCode = OpDefalutQueryStore.value;
    }
    this.init();
    this.loadListData();
  }
  init() {
    // 订单状态字典List
    this.getDictionaryList("outbound_status").then(data => {
      this.orderStatusList = data;
    });
    // 订单类型字典List
    this.getDictionaryList("outbound_type").then(data => {
      this.orderTypeList = data;
    });
    if (this.appCode === "speedbiz") {
      // 员工和顾问 List
      this.getStaffList({
        pageSize: 999,
        pageNum: 1
      }).then(data => {
        const staffList = this.$safeValue(data, "data.list", []).map(item => ({
          label: item.staffName,
          value: item.userCode
        }));
        this.staffList = staffList;
      });
    }
  }
  totalPartsQty = "";
  totalCostAmount = "";
  @Table.LoadDataMethod()
  loadListData() {
    return this.getOutWarehouseList({
      ...this.searchForm,
      orderItems: this.mix_sortParams,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.orderList = this.$safeValue(data, "data.list", []);
      this.totalPartsQty = this.$safeValue(data, "data.totalPartsQty", "");
      this.totalCostAmount = this.$safeValue(data, "data.totalCostAmount", "");
      return data;
    });
  }
  handleSwitchStatus() {
    this.mix_pageNum = 1;
    this.loadListData();
  }

  get searchList() {
    return [
      ...(this.appCode === "speedbiz-operation"
        ? [
            {
              label: t("v210831.store-name"),
              type: "select-search",
              value: OpDefalutQueryStore.value,
              prop: "storeCode",
              placeholder: t("v210801.please-enter-keyword"),
              selectList: this.storeList,
              searchFun: this.searchStore,
              clearable: false
            }
          ]
        : []),
      {
        label: "warehouse.outbound-type",
        type: "select",
        selectList: this.orderTypeList,
        value: "",
        prop: "outboundType"
      },
      ...(this.appCode === "speedbiz"
        ? [
            {
              label: "warehouse.outbound-people",
              type: "select",
              selectList: this.staffList,
              value: "",
              prop: "outboundUser"
            }
          ]
        : []),
      {
        label: "warehouse.outbound-date",
        type: "daterange",
        value: "",
        prop: "startOutboundDate"
      },
      {
        label: "v213.Outbound-status",
        type: "select",
        selectList: this.orderStatusList,
        value: "",
        prop: "outboundStatus"
      },
      {
        label: "other.relation-vehicle",
        type: "input",
        value: "",
        prop: "customerPlateCode"
      },
      {
        label: "v213.Related-order-No",
        type: "input",
        value: "",
        prop: "orderNo"
      },
      {
        label: "warehouse.outbound-no",
        type: "input",
        value: "",
        prop: "outboundNo"
      }
    ];
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "startOutboundDate") {
          this.searchForm["startOutboundDate"] = item.value?.[0] || "";
          this.searchForm["endOutboundDate"] = item.value?.[1] || "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    if (this.permitApp("speedbiz-operation") && !this.searchForm.storeCode) {
      return this.$message.error(t("v210831.please-select-a-store"));
    }
    this.loadListData();
  }
  handleEdit(row) {
    this.$router.push(`/inventory/out-warehouse-edit/${row.outboundNo}`);
  }
  handleView(row) {
    let { href } = this.$router.resolve({
      path: `/inventory/out-warehouse-view/${row.outboundNo}`
    });
    window.open(href, "_blank");
  }
  handleLinkOrderView(row) {
    let { href } = this.$router.resolve({
      path: `/service/view/${row.orderNo}?tenantCode=${row.tenantCode || ""}`
    });
    window.open(href, "_blank");
  }

  handleComplete() {
    this.btnStartLoading();
    this.outWarehouseComplete({
      outboundNo: this.activeRow.outboundNo,
      _httpOptions: { errorMessage: false }
    })
      .then(
        data => {
          this.$message.success(t("warehouse.outbound-success") as string);
          this.loadListData();
          if (data.data.validateInventoryAlert === "1") {
            this.getOutWarehouseDetail({
              outboundNo: this.activeRow.outboundNo
            }).then(data => {
              const partsCodeList = data.data.detailList.map(item => item.partsCode);
              if (partsCodeList && partsCodeList.length > 0) {
                this.queryInventoryAndNotice(partsCodeList);
              }
            });
          }
          this.showOutConfirmTips = false;
        },
        res => {
          this.showOutConfirmTips = false;
          if (res.code === "speedbiz.inventory.outbound-cost-changed") {
            this.$confirm(res.message, t("v210831.tips"), {
              confirmButtonText: t("v216_6.continue-outbound"),
              cancelButtonText: t("v216_6.temporarily-not-outbound"),
              type: "warning"
            })
              .then(() => {
                this.handleComplete();
              })
              .catch(() => {
                this.init();
              });
          } else {
            this.$message.error(res.message);
          }
        }
      )
      .finally(() => {
        this.btnStopLoading();
      });
  }
  storeList: any = [OpDefalutQueryStore];
  searchStore(val = "") {
    this.getStoreList({
      pageNum: 1,
      pageSize: 10,
      storeName: val
    }).then(data => {
      this.storeList = data.data.list
        ? data.data.list.map(item => {
            item.label = item.storeName;
            item.value = item.storeCode;
            return item;
          })
        : [];
    });
  }
  // 2.10
  activeRow: any = {};
  showOutConfirmTips: boolean = false;
  handleShowOutConfrimTips(row) {
    this.showOutConfirmTips = true;
    this.activeRow = row;
  }
}
